export default "__VITE_ASSET__BhoKyydu__"